module.exports = __webpack_public_path__ + "static/media/Banner.1727d969.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/Banner.webp
// module id = 443
// module chunks = 5